/* eslint-disable */
import axios from 'axios';
import { Message, Notification } from 'element-ui';
import Cookies from "js-cookie";

// 创建axios实例
const service = axios.create({
  timeout: 0 // 请求超时时间
})
/*eslint-disable*/
let isLoginTimeOut = true;
let messageShow = true;

// request拦截器
service.interceptors.request.use(
  config => {
    //  ----------------------------------------- 过滤空格 ---------------------------------------------------------
    if (config.data) {
      Object.keys(config.data).forEach(key => {
        if (config.data[key] && typeof config.data[key] === 'string') config.data[key] = config.data[key].trim();
      })
    }
    if (config.params) {
      Object.keys(config.params).forEach(key => {
        if (config.params[key] && typeof config.params[key] === 'string') config.params[key] = config.params[key].trim()
          .replace(/\[/g, encodeURIComponent('[')).replace(/]/g, encodeURIComponent(']'));
      })
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行编辑
     */
    const res = response.data
    if (res.code !== 200) {
      if (messageShow) {
        messageShow = false;
        Message({ message: res.message, type: 'error', duration: 3 * 1000 });
        setTimeout(() => {
          messageShow = true;
        }, 3000)
      }
      if (+res.transCode === 401) {
        Cookies.remove('cmsweb');
        window.location.href = '/login'
      }
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    let message = ''
    if ([413, 414, 431].includes(error.response.status)) message = '请求字符超长，请修改。';
    if (messageShow) {
      messageShow = false;
      Message({ message: message, type: 'error', duration: 3 * 1000 })
      setTimeout(() => {
        messageShow = true;
      }, 3000)
    }
    return Promise.reject(error)
  }
)

export default service
